var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3693 16.741L18.5254 12.897L16.1782 10.5379C15.1843 9.544 13.5677 9.544 12.5738 10.5379L6.37071 16.741C5.55641 17.5553 6.14318 18.9444 7.28081 18.9444H13.9988H21.4592C22.6088 18.9444 23.1836 17.5553 22.3693 16.741Z",
    fill: "#6CC91A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreen2);
export default __webpack_public_path__ + "static/media/arrow-up-green-2.2150cfd48479f779950b422d99da523e.svg";
export { ForwardRef as ReactComponent };